export default __webpack_public_path__ + "static/media/project.020b3dca.svg";